module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.3627/img/cms-free-signup.png"